import { render } from "./VehicleBasePriceTabComponent.vue?vue&type=template&id=385d5138&scoped=true"
import script from "./VehicleBasePriceTabComponent.vue?vue&type=script&lang=js"
export * from "./VehicleBasePriceTabComponent.vue?vue&type=script&lang=js"

import "./VehicleBasePriceTabComponent.vue?vue&type=style&index=0&id=385d5138&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-385d5138"]])

export default __exports__